import { actionTypes } from 'BASE/store/types';
import { storage } from 'BASE/common/util/util.storage';

export default {    
    watch: {
        skinColor: {
            immediate: true,
            handler(skin) {
                this.setBodySkinClass(skin);
            },
        },        
        $route (to, from){
            this.setBodySkinClass(this.skinColor);      
        }
    },
    computed: {        
        skinColor() {
            return this.$store.state.userinfo.skinClass;
        },
    },
    methods: {
        async changeSkin(skin){
            storage.local.set(storage.keys.SKIN_COLOR, skin);
            await this.$store.dispatch(actionTypes.USER_INFO_SKIN_COLOR,{skinClass: skin });
        },
        setBodySkinClass(skin){
            if(skin == 'tiffanyBlue') {
                document.body.className = `gray-bg color1`;
            } else if(skin == 'dark') {
                document.body.className = `gray-bg color2`;
            } else if(skin == 'copper') {
                document.body.className = `gray-bg color3`;
            } else {
                document.body.className = `gray-bg ${skin}`;
            } 
        },
    },    
    async mounted() {                
        let skinColor = storage.local.get(storage.keys.SKIN_COLOR) || 'tiffanyBlue';
        await this.$store.dispatch(actionTypes.USER_INFO_SKIN_COLOR, { skinClass: skinColor });
    },
};